import api from './client';

export const getConversations = () => api.get('/messages/conversations').then(r => r.data);
export const getMessages = (userId, params) => api.get(`/messages/${userId}`, { params }).then(r => r.data);
export const sendMessage = (data) => api.post('/messages', data).then(r => r.data);
export const getUnreadCount = () => api.get('/messages/unread/count').then(r => r.data);
export const deleteMessage = (id) => api.delete(`/messages/${id}`).then(r => r.data);
